export enum VehicleReportStatus {
		Created,
		Approved,
		Rejected,
		AppointmentCreated 
}
